'use client';

import { Card } from '@repo/ui';
import { ScrollableContainer } from '../common/scrollable-container';
import type { CriticalValueResult } from '../../../lib/stats/critical-value';

interface CriticalValueProps {
  visualizationData: CriticalValueResult | null;
}

export function CriticalValue({ visualizationData: result }: CriticalValueProps) {
  if (!result) {
    return null;
  }

  return (
    <ScrollableContainer>
      <div className="space-y-6">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Critical Value Results</h3>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-muted-foreground">Distribution</p>
                <p className="font-medium">{result.distributionType.toUpperCase()}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Significance Level (α)</p>
                <p className="font-medium">{(result.alpha * 100).toFixed(1)}%</p>
              </div>
              {result.degreesOfFreedom && (
                <div>
                  <p className="text-sm text-muted-foreground">Degrees of Freedom</p>
                  <p className="font-medium">{result.degreesOfFreedom}</p>
                </div>
              )}
              <div>
                <p className="text-sm text-muted-foreground">Critical Value</p>
                <p className="font-medium text-primary">{result.criticalValue.toFixed(4)}</p>
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Interpretation</h3>
          <p className="text-muted-foreground">{result.interpretation}</p>
        </Card>
      </div>
    </ScrollableContainer>
  );
} 